// extracted by mini-css-extract-plugin
export default {"ant-menu-horizontal":"style_ant-menu-horizontal__M5OkT","topbar":"style_topbar__LrIyX"};